import { Button } from "@gigpro/ui/Button";
import type { ErrorComponentProps } from "@tanstack/react-router";
import ErrorStateIcon from "components/CommonUIStates/ErrorState.svg?react";
import { env } from "config/env";
import React from "react";
import { copyToClipboard } from "utils/copyToClipboard";
import { reportRouteError } from "./reportRouteError";

export const ErrorBoundary = ({ error }: Pick<ErrorComponentProps, "error">) => {
  const errorString =
    error instanceof Error ? (error.stack ?? JSON.stringify(error, null, 2)) : JSON.stringify(error, null, 2);
  React.useEffect(() => {
    reportRouteError(error);
  }, [error]);
  return (
    <div className="flex h-full flex-col items-center justify-center bg-white p-10 text-center">
      <ErrorStateIcon className="mb-8 h-24 w-auto text-black sm:h-32 md:mb-8" />
      <h1 className="mb-2 text-enormous text-gray">Ooops, something went wrong.</h1>
      <p className="mb-4 text-large text-gray">
        Try reloading the page or contacting our{" "}
        <a className="text-black" href={env.REACT_APP_BUSINESS_SUPPORT_URL} target="_blank" rel="noopener noreferrer">
          support team
        </a>
      </p>
      {errorString && (
        <div className="flex max-w-[100vw] flex-col gap-1 px-2">
          <p className="text-left text-normal">Send this error message along to help us fix the problem:</p>
          <pre className="overflow-auto border border-black bg-background p-1 text-left text-small">{errorString}</pre>
          <Button variant="contained" size="small" onClick={() => void copyToClipboard(errorString)}>
            Copy error to clipboard
          </Button>
        </div>
      )}
    </div>
  );
};
